import { getPostHog } from './_posthog.client';

export function identify(userId: string, properties?: Record<string, string | boolean | null | undefined>) {
  getPostHog()?.identify(userId, properties);
}

export function reset() {
  getPostHog()?.reset();
}

export function capture(event: string, properties?: Record<string, unknown>) {
  getPostHog()?.capture(event, properties);
}

export function getDistinctId(): string | undefined {
  return getPostHog()?.get_distinct_id();
}

export function getProperty(key: string): unknown {
  return getPostHog()?.get_property(key);
}
